<template>
    <div 
    v-if="showControllaer"
    class="dialog-reservation modal"
    >
        <div class="dialog">
            <div class="header">
                <i class="el-icon-close btn-close" @click="cancelHandler"></i>

                <div class="title">
                    产品预约
                </div>

                <div class="desc">
                    我们将在收到您的信息后及时联系您，为您提供最佳的详细方案
                </div>
            </div>

            <div class="body">
                <my-form
                    v-model="form"
                    labelPosition="top"
                    size="large"
                    @submit="submitHandler"
                >
                    <el-form-item
                        label="单位名称："
                        prop="collegeName"
                        :rules="newRule('单位名称', 'required')"
                    >
                        <el-input v-model="form.collegeName"></el-input>
                    </el-form-item>
                    <el-form-item
                        label="联系人："
                        prop="customName"
                        :rules="newRule('联系人', 'required')"
                    >
                        <el-input v-model="form.customName"></el-input>
                    </el-form-item>
                    <el-form-item
                        label="联系方式："
                        prop="customMobile"
                        :rules="newRule('联系方式', 'required')"
                    >
                        <el-input v-model="form.customMobile"></el-input>
                    </el-form-item>

                    <template
                        slot="btn"
                        slot-scope="scope"
                    >
                        <el-button
                            type="primary"
                            @click="scope.submitHandler"
                        >提交</el-button>
                    </template>
                </my-form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            form: {
                collegeName: '',
                customName: '',
                customMobile: '',
            },
        };
    },
    computed: {
        showControllaer: {
            get() {
                return this.$store.getters['global-dialog/getGlobalDialogVisible']('reservation');
            },
            set(val) {
                this.$store.commit('global-dialog/updateDialogVisible', {
                    name: 'reservation',
                    visible: val,
                });
            },
        },
    },
    methods: {
        submitHandler() {
            this.$post('/reservation/add', this.form, data => {
                showMsgBox('提交完成，我们会尽快与您取得联系');

                this.cancelHandler();
            });
        },
        cancelHandler() {
            this.showControllaer = false;

            this.form = {
                collegeName: '',
                customName: '',
                customMobile: '',
            };
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@css/var.scss';

.dialog-reservation {
    &.modal {
        background: rgba(0, 0, 0, 0.1);
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 90;

        .dialog {
            width: 585px;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            background-color: #ffffff;

            .header {
                display: flex;
                flex-direction: column;
                justify-content: center;
                height: 121px;
                position: relative;
                background: url(/images/bg-dialog-reservation.png);
                background-size: cover;
                background-position: top center;
                padding: 0 34px;
                cursor: default;

                .btn-close {
                    font-size: 20px;
                    position: absolute;
                    top: 14px;
                    right: 14px;
                    color: #1c1c1c;
                    cursor: pointer;

                    &:hover {
                        color: $primaryColor;
                    }
                }

                .title {
                    font-size: 26px;
                    color: #2e2f30;
                    line-height: 1em;
                    font-weight: bold;
                }

                .desc {
                    font-size: 16px;
                    color: #2e2f30;
                    margin-top: 22px;
                    line-height: 1em;
                }
            }

            .body {
                padding: 25px 32px;

                ::v-deep {
                    .el-form--label-top {
                        .el-form-item__label {
                            padding: 0 0 12px 0;
                            font-size: 18px;
                            line-height: 1em;
                            color: #212121;
                        }
                    }

                    .el-button {
                        font-size: 22px;
                        padding: 16px 166px;
                    }
                }
            }
        }
    }
}
</style>